/**
 * Truncates the given text accurately to the specified symbol limit. Trimms trailing spaces, periods, commas, and hyphens.
 * Attaches ellipsis to indicate truncation.
 * If the text to crop has length smaller than the buffer, the entire text is returned.
 *
 * @param text - The text to be truncated.
 * @param symbolsLimit - The maximum number of symbols to retain in the truncated text.
 * @param buffer - The buffer value to determine if the entire text should be returned instead of truncating. Default is 10.
 * @returns The truncated text with an ellipsis if truncation occurred, or the entire text if it is within the limit.
 */
export default function truncateAccurately(text: string, symbolsLimit: number, buffer = 10) {
    if (!text || !symbolsLimit) {
        return '';
    }

    if (text.length < symbolsLimit + buffer) {
        return text;
    }

    const endTrimRegex = /[ \\.,-]+$/; // removes .,- and spaces from the end of the string
    const truncated = text.slice(0, symbolsLimit);

    return `${ truncated.replace(endTrimRegex, '') }...`;
}
